import * as React from 'react'

import { Site } from '@/components/ui/shadcn-compat'

import HeaderBrand from './HeaderBrand.react'

class Header extends React.Component {  
  render () {
    return (
      <Site className="site-header">
        <HeaderBrand />
      </Site>
    )
  }
}

export default Header
